import cx from 'classnames';
import PlusSVG from '@redturtle/qubicaamf-theme/components/Icons/PlusSVG';
import CTAstyles from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA.module.css';
import styles from './styles.module.css';

const LoadMorePagination = ({ loadMore }) => {
  return (
    <button
      className={cx(
        CTAstyles.cta_link,
        CTAstyles.cta_big_button_style,
        styles.customHeightButton,
      )}
      onClick={loadMore}
    >
      <PlusSVG />
    </button>
  );
};

export default LoadMorePagination;
